export default __webpack_public_path__ + "static/media/5.d78855c7.jpg";